var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#33D713"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5572 7.20541C13.9476 6.81475 13.9474 6.18159 13.5567 5.79119C13.1661 5.4008 12.5329 5.40101 12.1425 5.79166L13.5572 7.20541ZM7.85015 11.5016L7.14304 12.2087C7.33062 12.3963 7.58504 12.5016 7.85031 12.5016C8.11559 12.5015 8.36997 12.3961 8.55749 12.2085L7.85015 11.5016ZM5.85725 8.09448C5.46673 7.70395 4.83356 7.70395 4.44304 8.09448C4.05252 8.485 4.05252 9.11816 4.44304 9.50869L5.85725 8.09448ZM12.1425 5.79166L7.1428 10.7947L8.55749 12.2085L13.5572 7.20541L12.1425 5.79166ZM8.55725 10.7945L5.85725 8.09448L4.44304 9.50869L7.14304 12.2087L8.55725 10.7945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckGreen);
export default __webpack_public_path__ + "static/media/icon-Check-Green.6b3a3e4a6b63917967e511565d5aab08.svg";
export { ForwardRef as ReactComponent };